export default "__VITE_ASSET__zpJdfxZR__$_?url__"